import { useQuery } from '@tanstack/react-query'
import { getSolutionDetail } from './api/apiCalls'
import { useParams } from 'react-router-dom'
import { Loading } from 'react-daisyui'
import BaseSecondaryHero from '../../components/layout/BaseSecondaryHero'
import DynamicSection from './components/DynamicSection'

export default function SolutionDetail() {

    const { id } = useParams()

    const { data: solutionDetail, isLoading: solutionDetailLoading } = useQuery({
        queryKey: ["solutionDetail", id],
        queryFn: () => getSolutionDetail(id ?? ""),
    })

    if (solutionDetailLoading || !solutionDetail) {
        return <Loading />
    }
console.log("solutionDetail", solutionDetail)
    return (
        <div className='w-full'>
            <BaseSecondaryHero heading={solutionDetail.hero} />
            <DynamicSection dynamic={solutionDetail.dynamic} />
        </div>
    )
}
